import { SYSTEM_TYPES } from "../config/systemTypes";

export type NodeDisplayImageSource = 'node' | 'product' | 'systemType' | 'none';

export interface NodeDisplayImage {
    src: string | null;
    source: NodeDisplayImageSource;
}

/** Thumbnail URL of the node's own image (`installedBaseNode.image`), if set and selected. */
export const getNodeImageThumbnail = (node: any): string | null =>
    node?.image?.file?.thumbnailLink ?? null;

/**
 * Picks the image a node tile / nameplate should show. The user-set node image
 * wins; assets fall back to the catalog product image and systems to the static
 * PNG per system type. `source: 'none'` means the caller renders its own
 * fallback (branded placeholder for assets/systems, tinted node-type icon otherwise).
 *
 * Expects the node to carry `image { file { thumbnailLink } }`,
 * `assetLocation.asset.product.image.thumbnailLink` and `system.systemType`
 * as far as the calling query selects them.
 */
export const resolveNodeDisplayImage = (node: any): NodeDisplayImage => {
    const nodeImage = getNodeImageThumbnail(node);
    if (nodeImage) return { src: nodeImage, source: 'node' };

    const productImage = node?.assetLocation?.asset?.product?.image?.thumbnailLink;
    if (productImage) return { src: productImage, source: 'product' };

    const systemType = node?.system?.systemType;
    const systemImage = systemType
        ? SYSTEM_TYPES.find((entry) => entry.value === systemType)?.image
        : undefined;
    if (systemImage) return { src: systemImage, source: 'systemType' };

    return { src: null, source: 'none' };
};
